import { ROLE_TEMPLATE_INDEX } from '@his/shared';

export function holdsLicensedRole(roleCodes: readonly string[]): boolean {
  return roleCodes.some((code) => ROLE_TEMPLATE_INDEX.get(code)?.licensed);
}

export function licenceRequired(isDoctor: boolean, roleCodes: readonly string[], wasfaty: boolean): boolean {
  return isDoctor || (wasfaty && roleCodes.includes('pharmacist'));
}

export function generatePassword(): string {
  const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
  const random = crypto.getRandomValues(new Uint32Array(11));
  const body = [...random].map((n) => alphabet[n % alphabet.length]).join('');
  return `${body.slice(0, 8)}${'AKMPRT'[random[8] % 6]}${'aemnrt'[random[9] % 6]}${random[0] % 10}${'!@#$%&'[random[10] % 6]}`;
}
